import Main from '@/views/main.vue'

import {devicelistMenuRouter} from './devicelist'

const deviceMenuRouter = {
  has: 'deviceManager',
  path: '/',
  icon: 'android-people',
  name: 'deviceMenuRouter',
  title: '设备管理',
  component: Main,
  children: [
    ...devicelistMenuRouter
  ]
}

export {deviceMenuRouter}



// WEBPACK FOOTER //
// ./src/router/device/index.js